
import apiHelpers from './apiHelpers.js';
import { mapCrudStoreGen } from '@/helpers/utils/storeHelpers.js';

let defaultForm = {
  accessVendorIds: [],
  accessBrandsIds: [],
  accessWarehouseIds: [],
  permissions: [],
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  newPassword: '',
  projectId: '',
  roleType: '',
  isManager: false,
  moreRoles: []
};

let defaultFilters = {
  search: '',
  brandId: '',
  email: '',
  warehouseId: '',
  hasPermissions: []
};

let genedStore = mapCrudStoreGen(defaultForm, defaultFilters, apiHelpers);

let ItemModule = {
  namespaced: true,

  state: () => ({
    ...genedStore.state,
    permissionGroupedUp: [
      {
        groupName: 'Storefront Orders',
        permissions: [
          'pm.orders.view',
          'pm.orders.viewExtended',
          'pm.orders.view.financeMargin',
          'pm.orders.view.connectLog',
          'pm.orders.create',
          'pm.orders.edit',
          'pm.orders.cancel',
          'pm.orders.markShipped',
          'pm.orders.awaitingShip',
          'pm.orders.undoPending',
          'pm.orders.splitOrder',
          'pm.orders.reship',
          'pm.orders.putOnHold',
          'pm.orders.removeOnHold',
          'pm.orders.bulkUpdate.main',
          'pm.orders.downloadInvoice',
          'pm.orders.simulateSunbasket',
          'pm.orders.checkout.view',
          'pm.orders.checkout.create'
        ]
      },
      {
        groupName: 'Storefront Orders: Fulfillment',
        permissions: [
          'pm.orders.fulfill',
          'pm.fulfillment.brandFulfillmentBoxes',
        ]
      },
      {
        groupName: 'Order Returns',
        permissions: [
          'pm.orderReturns.view',
          'pm.orderReturns.confirmReceived',
        ]
      },
      {
        groupName: 'Storefronts',
        permissions: [
          'pm.storefronts.view',
          'pm.storefronts.create',
          'pm.storefronts.edit',
          'pm.storefronts.enableOrDisable',
          'pm.storefronts.retryAllVirtual',
          'pm.storefront.orderGroups.view',
          'pm.storefront.orderGroups.addOrUpdate',
          'pm.storefront.warehouses.view',
          'pm.storefront.warehouses.addOrUpdate',
        ]
      },
      {
        groupName: 'Storefront: Products',
        permissions: [
          'pm.storefront.products.view',
          'pm.storefront.products.create',
          'pm.storefront.products.manage',
          'pm.storefront.products.canMap',
          'pm.storefront.productGroups.view',
          'pm.storefront.productGroups.addOrUpdate'
        ]
      },
      {
        groupName: 'Storefront: Rate Shops',
        permissions: [
          'pm.other.storefrontRateShops',
          'pm.other.storefrontRateShops.manage',
        ]
      },
      {
        groupName: 'Order Tags',
        permissions: [
          'pm.storefront.orderTags.view',
          'pm.storefront.orderTags.create',
        ]
      },
      {
        groupName: 'Inventory',
        permissions: [
          'pm.warehouses.items.view',
          'pm.warehouses.items.viewInventoryByLocation',
          'pm.warehouses.items.viewItemDetails',
          'pm.warehouses.items.create',
          'pm.warehouses.items.update',
          'pm.warehouses.items.confirm',
          'pm.warehouses.items.import',
          'pm.warehouses.productGroups.view',
          'pm.warehouses.productGroups.addOrUpdate'
        ]
      },
      {
        groupName: 'Inventory: Adjustments',
        permissions: [
          'pm.warehouses.diu.view',
          'pm.warehouses.diu.create',
        ]
      },
      {
        groupName: 'ASN / Inbound',
        permissions: [
          'pm.warehouses.asn.view',
          'pm.warehouses.asn.create',
          'pm.warehouses.asn.update',
          'pm.warehouses.asn.receive',
          'pm.warehouses.asn.confirm',
          'pm.warehouses.asn.autoConfirm',
          'pm.warehouses.asn.cancel',
        ]
      },
      {
        groupName: 'Warehouse Transfers',
        permissions: [
          'pm.warehouses.wt.view',
          'pm.warehouses.wt.create',
          'pm.warehouses.wt.update',
          'pm.warehouses.wt.receive',
          'pm.warehouses.wt.confirm',
          'pm.warehouses.wt.autoConfirm',
          'pm.warehouses.wt.cancel',
        ]
      },
      {
        groupName: 'Purchase Orders',
        permissions: [
          'pm.warehouses.purchaseOrders.view',
          'pm.warehouses.purchaseOrders.create',
          'pm.warehouses.purchaseOrders.edit',
          'pm.warehouses.purchaseOrders.confirm',
          'pm.warehouses.purchaseOrders.autoConfirm',
          'pm.warehouses.purchaseOrders.complete',
          'pm.warehouses.purchaseOrders.reopen',
          'pm.warehouses.purchaseOrders.cancel',
          'pm.warehouses.purchaseOrders.workOrders.view',
          'pm.warehouses.purchaseOrders.workOrders.create',
          'pm.communications.purchaseOrders.internalChannel',
        ]
      },
      {
        groupName: 'Bulk Orders',
        permissions: [
          'pm.warehouses.bulkShipments.view',
          'pm.warehouses.bulkShipments.create',
          'pm.warehouses.bulkShipments.request',
          'pm.warehouses.bulkShipments.confirm',
          'pm.warehouses.bulkShipments.apiConfirm',
        ]
      },
      {
        groupName: 'Other Small Parcels (deprecated)',
        permissions: [
          'pm.warehouses.smallparcels.view',
          'pm.warehouses.smallparcels.create',
        ]
      },
      {
        groupName: 'Warehouses',
        permissions: [
          'pm.warehouses.view',
          'pm.warehouses.create',
          'pm.warehouses.edit',
        ]
      },
      {
        groupName: 'Client Billing',
        permissions: [
          'pm.customerBilling.invoices.view',
          'pm.customerBilling.invoices.approve',
          'pm.customerBilling.billingEntries',
          'pm.customerBilling.rateCards',
          'pm.customerBilling.ptcFiles',
          'pm.billing.factoringLedger',
        ]
      },
      {
        groupName: 'Carrier Invoice System',
        permissions: [
          'pm.carrierBilling.invoices',
          'pm.carrierBilling.billingEntries',
        ]
      },
      {
        groupName: 'Manufacturing',
        permissions: [
          'pm.manufacturing.workOrders.view',
          'pm.manufacturing.workOrders.addOrUpdate',
          'pm.manufacturing.rndProjects.view',
          'pm.manufacturing.rndProjects.addOrUpdate',
          'pm.manufacturing.billOfMaterials.view',
          'pm.manufacturing.billOfMaterials.addOrUpdate',
          'pm.manufacturing.vendors.view',
          'pm.manufacturing.vendors.addOrUpdate',
        ]
      },
      {
        groupName: 'Integrations: Bulk Orders',
        permissions: [
          'pm.integrations.orderSourceIntegrations.view',
          'pm.integrations.orderSourceIntegrations.edit',
        ]
      },
      {
        groupName: 'Integrations: Other',
        permissions: [
          'pm.integrations.shipstation.orderTags',
          'pm.integrations.shipstation.storefrontProducts',
          'pm.integrations.shipstation.stores',
          'pm.integrations.extensiv.uom',
          'pm.integrations.extensiv.receipts',
          'pm.integrations.extensiv.facilities',
          'pm.integrations.extensiv.customers',
          'pm.integrations.extensiv.customerOrders',
          'pm.integrations.extensiv.carrierServices',
          'pm.integrations.extensiv.carriers',
          'pm.integrations.extensiv.billingCodes',
          'pm.integrations.extensiv.adjustments',
        ]
      },
      {
        groupName: 'API Access',
        permissions: [
          'pm.api.apikeys.view',
          'pm.api.apikeys.manage',
          'pm.api.storefronts.view',
          'pm.api.storefronts.create',
          'pm.api.storefronts.disable',
          'pm.api.orderGroups.view',
          'pm.api.orderGroups.manage',
          'pm.api.warehouses.view',
          'pm.api.warehouses.manage',
          'pm.api.automation.webhooks.view',
          'pm.api.automation.webhooks.manage',
          'pm.api.webhooks.manager',
        ]
      },
      {
        groupName: 'Automation',
        permissions: [
          'pm.automation.log',
          'pm.automation.triggers',
          'pm.automation.contentTemplates',
        ]
      },
      {
        groupName: 'Analytics',
        permissions: [
          'pm.analytics.parcelShipments',
          'pm.analytics.fulfillmentStats',
          'pm.analytics.clientBillingStats',
          'pm.analytics.carrierBillingStats',
        ]
      },
      {
        groupName: 'Reports',
        permissions: [
          'pm.reports.storefrontProdStats',
          'pm.reports.wmsProdStats',
          'pm.reports.orderedItems',
          'pm.reports.orderFulfillment',
          'pm.reports.shippedCount',
          'pm.reports.wareTransSummary',
        ]
      },
      {
        groupName: 'Clients',
        permissions: [
          'pm.clients.view',
          'pm.clients.manage',
          'pm.clients.addOrUpdate',
        ]
      },
      {
        groupName: 'Teams & Users',
        permissions: [
          'pm.teams.users.view',
          'pm.teams.users.invite',
          'pm.teams.users.remove',
          'pm.users.manage.view',
          'pm.users.manage.addOrUpdate',
          'pm.userTeams.views',
          'pm.userTeams.manage',
        ]
      },
      {
        groupName: 'Support',
        permissions: [
          'pm.support.tickets.viewAll',
          'pm.support.tickets.create',
          'pm.support.tickets.update',
        ]
      },
      {
        groupName: 'Knowledgebase',
        permissions: [
          'pm.knowledgebase.view',
          'pm.knowledgebase.addOrUpdate',
        ]
      },
      {
        groupName: 'Dashboard',
        permissions: [
          'pm.dashboard.nonecom.view',
        ]
      },
      {
        groupName: 'Roles',
        permissions: [
          'pm.is_lacore_admin',
          'pm.is_lacore_team_member',
          'pm.is_warehouse_partner',
          'pm.is_vendor_partner',
          'pm.is_client',
          'pm.is_end_partner',
        ]
      },
      {
        groupName: 'System & Mappings',
        permissions: [
          'pm.other.shipCodeMappings',
          'pm.other.shipCodeMappings.manage',
          'pm.other.skuMaintenance',
          'pm.other.systemLogs',
          'pm.other.userLogs',
        ]
      },
    ],
    humanReadablePermissions: [
      {"id": "pm.api.apikeys.view", "label": "View API Keys"},
      {"id": "pm.api.apikeys.manage", "label": "Manage API Keys"},

      {"id": "pm.api.storefronts.view", "label": "API Access - View Storefronts"},
      {"id": "pm.api.storefronts.create", "label": "API Access - Manage Storefronts"},
      {"id": "pm.api.storefronts.disable", "label": "API Access - Disable Storefronts"},
      {"id": "pm.api.orderGroups.view", "label": "API Access - View Order Groups"},
      {"id": "pm.api.orderGroups.manage", "label": "API Access - Manage Order Groups"},
      {"id": "pm.api.warehouses.view", "label": "API Access - View Warehouses"},
      {"id": "pm.api.warehouses.manage", "label": "API Access - Manage Warehouses"},
      {"id": "pm.api.automation.webhooks.view", "label": "API Access - View Webhook Automation"},
      {"id": "pm.api.automation.webhooks.manage", "label": "API Access - Config Webhook Automation"},
      
      {"id": "pm.warehouses.bulkShipments.apiConfirm", "label": "API Access - Confirm Bulk Orders"},

      {"id": "pm.teams.users.view", "label": "View Team Members"},
      {"id": "pm.teams.users.invite", "label": "Invite Team Members"},
      {"id": "pm.teams.users.remove", "label": "Remove Team Members"},

      {"id": "pm.users.manage.view", "label": "View User Management"},
      {"id": "pm.users.manage.addOrUpdate", "label": "Add or Update Users"},
      {"id": "pm.support.tickets.viewAll", "label": "View All Support Tickets"},
      {"id": "pm.warehouses.purchaseOrders.workOrders.create", "label": "Create Work Orders under POs"},
      {"id": "pm.warehouses.purchaseOrders.workOrders.view", "label": "View Work Orders under POs"},
      {"id": "pm.automation.log", "label": "View Automation Log"},
      {"id": "pm.automation.triggers", "label": "Manage Automation Triggers"},
      {"id": "pm.automation.contentTemplates", "label": "Manage Content Templates"},
      {"id": "pm.support.tickets.create", "label": "Create Support Tickets"},
      {"id": "pm.support.tickets.update", "label": "Update Support Tickets"},
      {"id": "pm.clients.view", "label": "View Clients"},
      {"id": "pm.clients.manage", "label": "Manage Clients"},
      {"id": "pm.clients.addOrUpdate", "label": "Add or Update Clients"},
      {"id": "pm.storefronts.create", "label": "Create Storefronts"},
      {"id": "pm.storefronts.edit", "label": "Edit Storefronts"},
      {"id": "pm.storefronts.enableOrDisable", "label": "Enable or Disable Storefronts"},
      {"id": "pm.storefronts.retryAllVirtual", "label": "Mass Retry Virtual Orders"},
      {"id": "pm.storefronts.view", "label": "View Storefronts"},
      {"id": "pm.storefront.orderGroups.view", "label": "View Storefront Order Groups"},
      {"id": "pm.storefront.orderGroups.addOrUpdate", "label": "Add or Update Storefront Order Groups"},
      {"id": "pm.storefront.orderTags.create", "label": "Create Storefront Order Tags"},
      {"id": "pm.storefront.orderTags.view", "label": "View Storefront Order Tags"},
      {"id": "pm.storefront.products.create", "label": "Create Storefront Products"},
      {"id": "pm.storefront.products.manage", "label": "Manage Storefront Products"},
      {"id": "pm.storefront.products.canMap", "label": "Map Storefront Products"},
      {"id": "pm.storefront.products.view", "label": "View Storefront Products"},
      {"id": "pm.reports.storefrontProdStats", "label": "View Storefront Product Stats"},
      
      {"id": "pm.other.storefrontRateShops", "label": "View Rate Shops"},
      {"id": "pm.other.storefrontRateShops.manage", "label": "Manage Rate Shops"},
      
      {"id": "pm.reports.wmsProdStats", "label": "View Warehouse Product Stats"},
      {"id": "pm.reports.orderedItems", "label": "View Ordered Items Report"},
      {"id": "pm.reports.orderFulfillment", "label": "View Order Fulfillment Report"},
      {"id": "pm.reports.shippedCount", "label": "View Shipped Count Report"},
      {"id": "pm.reports.wareTransSummary", "label": "View Warehouse Transaction Summary"},
      {"id": "pm.dashboard.nonecom.view", "label": "Dashboard - Non-Ecom View"},
      {"id": "pm.orders.view", "label": "SO - View Orders"},
      {"id": "pm.orders.splitOrder", "label": "SO - Split Orders"},
      {"id": "pm.orders.reship", "label": "SO - Reship Orders"},
      {"id": "pm.orders.removeOnHold", "label": "SO - Remove Hold"},
      {"id": "pm.orders.putOnHold", "label": "SO - Put Orders on Hold"},
      {"id": "pm.orders.simulateSunbasket", "label": "SO - Simulate Sunbasket Orders (depr.)"},
      {"id": "pm.orders.downloadInvoice", "label": "SO - Download Customs Documents"},
      {"id": "pm.orders.markShipped", "label": "SO - Mark Orders as Shipped"},
      {"id": "pm.orders.awaitingShip", "label": "SO - Move to Awaiting Shipment"},
      {"id": "pm.orders.undoPending", "label": "SO- Undo Pending Fulfillment"},
      {"id": "pm.orders.edit", "label": "SO - Edit Orders"},
      {"id": "pm.orders.create", "label": "SO - Create Orders"},
      {"id": "pm.orders.cancel", "label": "SO  - Cancel Orders"},
      {"id": "pm.orders.bulkUpdate.main", "label": "SO - Bulk Update Orders"},
      {"id": "pm.orders.view.financeMargin", "label": "SO - View Finance Margin"},
      {"id": "pm.orders.view.connectLog", "label": "SO - View Connect Log"},
      {"id": "pm.orders.checkout.view", "label": "SO - View Checkout"},
      {"id": "pm.orders.checkout.create", "label": "SO - Create Checkout"},
      {"id": "pm.orders.viewExtended", "label": "SO - Extended View (Links to Shipped, Awaiting Payments)"},

      {"id": "pm.orders.fulfill", "label": "SO - Fulfillment"},
      {"id": "pm.fulfillment.brandFulfillmentBoxes", "label": "Fulfillment Boxes"},
      
      {"id": "pm.warehouses.productGroups.view", "label": "Product Groups: View"},
      {"id": "pm.warehouses.productGroups.addOrUpdate", "label": "Product Groups: Manage"},

      {"id": "pm.orderReturns.confirmReceived", "label": "Confirm Order Returns as Received"},
      {"id": "pm.orderReturns.view", "label": "View Order Returns"},
      {"id": "pm.billing.factoringLedger", "label": "View Factoring Ledger"},
      {"id": "pm.customerBilling.billingEntries", "label": "Manage Client Billing Entries"},
      {"id": "pm.customerBilling.invoices.view", "label": "View Client Invoices"},
      {"id": "pm.customerBilling.ptcFiles", "label": "Manage PTC Files"},
      {"id": "pm.customerBilling.rateCards", "label": "Manage Rate Cards"},
      {"id": "pm.other.shipCodeMappings.manage", "label": "Manage Ship Code Mappings"},
      {"id": "pm.other.shipCodeMappings", "label": "View Ship Codes"},
      {"id": "pm.other.skuMaintenance", "label": "Manage SKU Maintenance"},
      {"id": "pm.other.systemLogs", "label": "View System Logs"},
      {"id": "pm.other.userLogs", "label": "View User Logs"},
      {"id": "pm.integrations.orderSourceIntegrations.view", "label": "Bulk Order Sources: View"},
      {"id": "pm.integrations.orderSourceIntegrations.edit", "label": "Bulk Order Sources: Manage"},
      {"id": "pm.integrations.shipstation.orderTags", "label": "Manage ShipStation Order Tags"},
      {"id": "pm.integrations.shipstation.storefrontProducts", "label": "Manage ShipStation Storefront Products"},
      {"id": "pm.integrations.shipstation.stores", "label": "Manage ShipStation Stores"},
      {"id": "pm.integrations.extensiv.uom", "label": "Manage Extensiv UOM"},
      {"id": "pm.integrations.extensiv.receipts", "label": "Manage Extensiv Receipts"},
      {"id": "pm.integrations.extensiv.facilities", "label": "Manage Extensiv Facilities"},
      {"id": "pm.integrations.extensiv.customers", "label": "Manage Extensiv Customers"},
      {"id": "pm.integrations.extensiv.customerOrders", "label": "Manage Extensiv Customer Orders"},
      {"id": "pm.integrations.extensiv.carrierServices", "label": "Manage Extensiv Carrier Services"},
      {"id": "pm.integrations.extensiv.carriers", "label": "Manage Extensiv Carriers"},
      {"id": "pm.integrations.extensiv.billingCodes", "label": "Manage Extensiv Billing Codes"},
      {"id": "pm.integrations.extensiv.adjustments", "label": "Manage Extensiv Adjustments"},
      {"id": "pm.communications.purchaseOrders.internalChannel", "label": "Manage Purchase Orders Internal Channel"},
      {"id": "pm.manufacturing.rndProjects.view", "label": "View Manufacturing RnD Projects"},
      {"id": "pm.manufacturing.rndProjects.addOrUpdate", "label": "Create/Update Manufacturing RnD Projects"},
      {"id": "pm.manufacturing.workOrders.view", "label": "View Manufacturing Work Orders"},
      {"id": "pm.manufacturing.workOrders.addOrUpdate", "label": "Add or Update Manufacturing Work Orders"},
      {"id": "pm.manufacturing.vendors.view", "label": "View Manufacturing Vendors"},
      {"id": "pm.manufacturing.vendors.addOrUpdate", "label": "Add or Update Manufacturing Vendors"},
      {"id": "pm.manufacturing.billOfMaterials.view", "label": "View Bill of Materials"},
      {"id": "pm.manufacturing.billOfMaterials.addOrUpdate", "label": "Add or Update Bill of Materials"},
      {"id": "pm.warehouses.create", "label": "Create Warehouses"},
      {"id": "pm.warehouses.edit", "label": "Edit Warehouses"},
      {"id": "pm.warehouses.view", "label": "View Warehouses"},
      {"id": "pm.warehouses.asn.cancel", "label": "Cancel ASN"},
      {"id": "pm.warehouses.asn.create", "label": "Create ASN"},
      {"id": "pm.warehouses.asn.receive", "label": "Receive ASN"},
      {"id": "pm.warehouses.asn.view", "label": "View ASN"},
      {"id": "pm.warehouses.asn.update", "label": "Update ASN"},
      {"id": "pm.warehouses.asn.confirm", "label": "Confirm ASN"},
      {"id": "pm.warehouses.asn.autoConfirm", "label": "Their ASNs do not need to be Confirmed"},
      {"id": "pm.warehouses.wt.cancel", "label": "Cancel WT"},
      {"id": "pm.warehouses.wt.create", "label": "Create WT"},
      {"id": "pm.warehouses.wt.receive", "label": "Receive WT"},
      {"id": "pm.warehouses.wt.update", "label": "Update WT"},
      {"id": "pm.warehouses.wt.view", "label": "View WT"},
      {"id": "pm.warehouses.wt.confirm", "label": "Confirm WT"},
      {"id": "pm.warehouses.wt.autoConfirm", "label": "Their WTs do not need to be Confirmed"},
      {"id": "pm.warehouses.bulkShipments.confirm", "label": "Confirm Requested Bulk Orders"},
      {"id": "pm.warehouses.bulkShipments.create", "label": "Create Bulk Orders"},
      {"id": "pm.warehouses.bulkShipments.view", "label": "View Bulk Orders"},
      {"id": "pm.warehouses.bulkShipments.request", "label": "Request Bulk Shipment"},
      {"id": "pm.warehouses.smallparcels.view", "label": "View Small Parcels"},
      {"id": "pm.warehouses.smallparcels.create", "label": "Create Small Parcels"},
      {"id": "pm.warehouses.purchaseOrders.view", "label": "View Purchase Orders"},
      {"id": "pm.warehouses.purchaseOrders.reopen", "label": "Reopen Purchase Orders"},
      {"id": "pm.warehouses.purchaseOrders.edit", "label": "Edit Purchase Orders"},
      {"id": "pm.warehouses.purchaseOrders.confirm", "label": "Confirm Purchase Orders"},
      {"id": "pm.warehouses.purchaseOrders.create", "label": "Create Purchase Orders"},
      {"id": "pm.warehouses.purchaseOrders.complete", "label": "Complete Purchase Orders"},
      {"id": "pm.warehouses.purchaseOrders.cancel", "label": "Cancel Purchase Orders"},
      {"id": "pm.warehouses.purchaseOrders.autoConfirm", "label": "Auto-confirm Purchase Orders"},
      {"id": "pm.warehouses.items.view", "label": "View Inventory"},
      {"id": "pm.warehouses.items.update", "label": "Update Client Items"},
      {"id": "pm.warehouses.items.confirm", "label": "Confirm Client Items"},
      {"id": "pm.warehouses.items.create", "label": "Create Client Items"},
      {"id": "pm.warehouses.items.import", "label": "Import Client Items"},
      {"id": "pm.warehouses.items.viewInventoryByLocation", "label": "View Inventory by Location"},
      {"id": "pm.warehouses.items.viewItemDetails", "label": "View Warehouse Item Details Screen"},
      {"id": "pm.warehouses.diu.view", "label": "View Adjustments Updates"},
      {"id": "pm.warehouses.diu.create", "label": "Create Adjustments Updates"},

      {"id": "pm.integrations.carrierConfig", "label": "Integrations: Config Carriers"},
      
      {"id": "pm.storefront.productGroups.view", "label": "View Storefront Product Groups"},
      {"id": "pm.storefront.productGroups.addOrUpdate", "label": "Manage Storefront Product Groups"},
      {"id": "pm.storefront.warehouses.view", "label": "View Warehouse Item Groups"},
      {"id": "pm.storefront.warehouses.addOrUpdate", "label": "Manage Warehouse Item Groups"},
      {"id": "pm.carrierBilling.invoices", "label": "View Carrier Invoices"},
      {"id": "pm.carrierBilling.billingEntries", "label": "View Carrier Billing Charges"},

      // Role permissions
      {"id": "pm.is_lacore_admin", "label": "LaCore Admin Role"},
      {"id": "pm.is_lacore_team_member", "label": "LaCore Team Member Role"},
      {"id": "pm.is_warehouse_partner", "label": "Warehouse Partner Role"},
      {"id": "pm.is_vendor_partner", "label": "Vendor Partner Role"},
      {"id": "pm.is_client", "label": "Client Role"},
      {"id": "pm.is_end_partner", "label": "End Partner Role"},

      {"id": "pm.analytics.parcelShipments", "label": "Analytics: Parcel Shipments"},
      {"id": "pm.analytics.fulfillmentStats", "label": "Analytics: Fulfillment Stats"},
      {"id": "pm.analytics.clientBillingStats", "label": "Analytics: Client Billing Stats"},
      {"id": "pm.analytics.carrierBillingStats", "label": "Analytics: Carrier Billing Stats"},

      // Knowledgebase permissions
      {"id": "pm.knowledgebase.view", "label": "View Knowledgebase"},
      {"id": "pm.knowledgebase.addOrUpdate", "label": "Manage Knowledgebase"},

      // Customer billing approvals
      {"id": "pm.customerBilling.invoices.approve", "label": "Approve Client Invoices"},

      // User teams
      {"id": "pm.userTeams.views", "label": "View User Teams"},
      {"id": "pm.userTeams.manage", "label": "Manage User Teams"},

      // API Webhooks Manager
      {"id": "pm.api.webhooks.manager", "label": "Manage API Webhooks"}
  ]
  }),

  mutations: {
    ...genedStore.mutations
  },

  getters: {
    ...genedStore.getters,
    // a getter that takes a parameter, permission id, and returns a label
    getPermissionLabel: (state) => (permissionId) => {
      let permission = state.humanReadablePermissions.find((p) => p.id === permissionId);
      return permission ? permission.label : permissionId;
    }
  },

  actions: {
    ...genedStore.actions
  }
};

export default ItemModule;
